import React, { Component } from 'react';
import { connect } from 'react-redux';
import { hideSnackbar } from '../../redux/actions';
import { getClass } from '../../utils/component-helpers';

import './snackbar.scss';

class Snackbar extends Component {
  constructor(props) {
    super(props);

    this.timeout = null;
    this.snackbarTimeout = 3000;
  }

  componentDidUpdate(prevProps) {
    if (prevProps.show !== this.props.show && this.props.show) {
      this.timeout = setTimeout(() => {
        this.props.hideSnackbar();
      }, this.snackbarTimeout);
    }
  }

  componentWillUnmount() {
    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = null;
    }
  }

  render() {
    return (
      <div
        className={getClass(`snackbar-container`, {
          show: this.props.show,
        })}
      >
        <div className="text-container">
          <span className="display-text">{this.props.displayMsg || ''}</span>
        </div>
        {/* TODO: Add action button */}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    show: state.snackbarShow,
    displayMsg: state.snackbarMsg,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    hideSnackbar: () => dispatch(hideSnackbar()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Snackbar);
